import React, { useState, useEffect } from "react"
import axios from "axios"
import { Modal } from "reactstrap"
import { AvForm, AvField } from "availity-reactstrap-validation"
import { getCurrentUser } from "../../../helpers/Utils"
import { toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import Select from "react-select"

let selectedUserId = []

export default function FetchWeb(props) {
  const [loading, setLoading] = useState(false)
  const [Loading, setloading] = useState(false)
  const [newsletter, setNewsletter] = useState(
    props.fetch && props.fetch.latest_leads_only === 1 ? true : false
  )
  const [allSource, setAllSource] = useState([])
  const [allUsers, setAllUsers] = useState([])
  const [allGroups, setAllGroups] = useState([])
  const [groupedUsers, setGroupedUsers] = useState({})
  const [groupsLoading, setGroupsLoading] = useState(false)
  const [selectedView, setSelectedView] = useState("all") // 'all' or 'groups'
  const [selectedAllUsers, setSelectedAllUsers] = useState([]) // For preselected users in All Users view
  const [selectedGroupUsers, setSelectedGroupUsers] = useState({}) // For preselected users per group {groupId: [userOptions]}
  const [assignType, setAssignType] = useState("individual");
  const hasGroups =(allGroups && allGroups.length > 0) || Object.keys(groupedUsers).length > 0;
  const [sequenceData, setSequenceData] = useState([]);
  const hasSequence =(sequenceData && sequenceData.length > 0);
  // Handle view switching
  const handleViewChange = newView => {
    if (newView !== selectedView) {
      setSelectedView(newView)
    }
  }
  const [selectedSource, setSelectedSource] = useState(
    props.fetch && props.fetch.platform
  )
  const [api_value, setApi_value] = useState()
  const [sourceOptions, setSourceOptions] = useState({})
  const [showFacebookDocs, setShowFacebookDocs] = useState(false)
  const isSequenceTab = props.activeTab === "lead_sequence"
  const handlenewSource = platform => {
    setSelectedSource(platform)

    if (sourceOptions[platform]) {
      setApi_value(sourceOptions[platform])
    } else if (platform === "nexttech_mart") {
      setApi_value(
        `https://klikcrm.com/api/${localStorage.getItem(
          "company_name"
        )}/webhook/nexttechmart`
      )
    } else if (platform === "pharma_dove_bazaar") {
      setApi_value(
        `https://klikcrm.com/api/${localStorage.getItem(
          "company_name"
        )}/webhook/pharmadovebazaar`
      )
    } else {
      setApi_value("")
    }

    // Show Facebook documentation link when Facebook is selected
    if (platform && platform.toLowerCase().includes("facebook")) {
      setShowFacebookDocs(true)
    } else {
      setShowFacebookDocs(false)
    }
  }

  const getAllUsers = () => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/user?per_page=5000`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${
              getCurrentUser().token == null ? "" : getCurrentUser().token
            }`,
          },
        }
      )
      .then(function (res) {
        setAllUsers(res.data.data.data)
      })
      .catch(err => {
        console.log("err", err)
      })
  }

  const getAllGroups = () => {
    setGroupsLoading(true)

    // First, try to get all groups
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/groups`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${
              getCurrentUser().token == null ? "" : getCurrentUser().token
            }`,
          },
        }
      )
      .then(function (res) {
        const groups = res.data.data.data || res.data.data || []
        console.log("Fetched groups:", groups)
        setAllGroups(groups)

        // Check if groups already have users property
        const grouped = {}

        // Check if any group has users property
        const groupsWithUsers = groups.filter(
          g => g.users && g.users.length > 0
        )

        console.log(
          "Groups with users:",
          groupsWithUsers.length,
          "out of",
          groups.length
        )

        // Process all groups
        groups.forEach(group => {
          const users = group.users || []
          console.log(`Processing group "${group.name}":`, {
            id: group.id,
            usersCount: users.length,
            users: users,
          })
          grouped[group.id] = {
            name: group.name,
            users: users,
          }
        })

        console.log("Final grouped users object:", grouped)
        setGroupedUsers(grouped)
        setGroupsLoading(false)
      })
      .catch(err => {
        console.log("Error fetching groups:", err)
        setAllGroups([])
        setGroupedUsers({})
        setGroupsLoading(false)
      })
  }
  const getAllLeadSequence = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/lead-sequences`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${
              getCurrentUser()?.token ? getCurrentUser().token : ""
            }`,
          },
        }
      );

      const sequence = res?.data?.data || [];

      console.log("Fetched Sequence:", sequence);

      if (res?.data?.status) {
        setSequenceData(sequence);
      }
    } catch (err) {
      console.log("Error fetching sequence:", err);

      // ❌ REMOVE these (they are for groups, not sequence)
      // setAllGroups([])
      // setGroupedUsers({})
      // setGroupsLoading(false)

      setSequenceData([]); // ✅ correct fallback
    }
  }

  useEffect(() => {
    const apivalue = () => {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
            "company_name"
          )}/webhook/urls`,
          {
            headers: {
              "content-type": "application/json",
              Authorization: `Bearer ${
                getCurrentUser().token == null ? "" : getCurrentUser().token
              }`,
            },
          }
        )
        .then(function (res) {
          if (res.status) {
            setSourceOptions(res.data.data)
            setloading(false)
            if (props.fetch && props.fetch.platform) {
              setApi_value(res.data.data[props.fetch.platform])
              // Check if initial platform is Facebook
              if (props.fetch.platform.toLowerCase().includes("facebook")) {
                setShowFacebookDocs(true)
              }
            }
          } else {
            setloading(false)
          }
        })
        .catch(err => {})
    }

    apivalue()
  }, [props.fetch])

  const getAllSource = () => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/lead/fetch-from-api-source?per_page=5000`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${
              getCurrentUser().token == null ? "" : getCurrentUser().token
            }`,
          },
        }
      )
      .then(function (res) {
        setAllSource(res.data.data)
      })
  }

  const handleSource = value => {
    setSelectedSource(value)
  }

  const submitFetch = (e, value) => {
    setLoading(true)
    
    // Build individual user assignments
    const individualUserIds = selectedAllUsers.map(user => user.value)

    // Build group_user_assignments object for groups
    const groupUserAssignments = {}
    Object.entries(selectedGroupUsers).forEach(([groupId, users]) => {
      if (users && users.length > 0) {
        groupUserAssignments[groupId] = users.map(u => u.value)
      }
    })

    // Determine assignment type: if both individual and group assignments exist, use 'mixed'
    let assignmentType = "all"
    const hasIndividualUsers = individualUserIds.length > 0
    const hasGroupUsers = Object.keys(groupUserAssignments).length > 0
    if(props.activeTab == 'lead_sequence')
    {
      assignmentType='sequence';
    }else  if (hasIndividualUsers && hasGroupUsers) {
      assignmentType = "mixed"
    } else if (hasGroupUsers) {
      assignmentType = "groups"
    } else if (hasIndividualUsers) {
      assignmentType = "all"
    } 

    const api = axios.create()
    const CancelToken = axios.CancelToken
    const source = CancelToken.source()

    api.interceptors.request.use(config => {
      config.cancelToken = source.token
      return config
    })

    const timeout = 120000 // 2 minute

    setTimeout(() => {
      source.cancel("Timeout")
    }, timeout)
    if (props.fetch !== undefined) {
      let fetchWebhook = '';
        if (isSequenceTab) {
          fetchWebhook = 'sequence';
        } else {
          fetchWebhook = '';
        }
      axios
        .put(
          `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
            "company_name"
          )}/update-webhook/${props.fetch.id}`,
          {
            api_key: value.api_key,
            platform: value.platform,
            lead_source_id: value.lead_source_id,
            latest_leads_only: 1,
            assignment_type: assignmentType,
            assignees: individualUserIds,
            group_user_assignments: groupUserAssignments,
            profile_id: value.profile_id,
          },
          {
            headers: {
              Authorization: `Bearer ${
                getCurrentUser().token == null ? "" : getCurrentUser().token
              }`,
            },
          }
        )
        .then(function (res) {
          if (res.data.status) {
            setLoading(false)
            props.setIsOpen(false)
            props.setnewModal_standard(false)
            props.setFetch({
              ...res.data.data,
              sequenceData: sequenceData,
            });
            toast.success(res.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            })
          } else {
            setLoading(false)
            toast.error(res.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            })
          }
        })
    } else {
      let fetchWebhook = '';
        if (isSequenceTab) {
          fetchWebhook = 'sequence';
        } else {
          fetchWebhook = '';
        }
      axios
        .post(
          `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
            "company_name"
          )}/store-webhooks`,
          {
            api_key: value.api_key,
            platform: value.platform,
            lead_source_id: value.lead_source_id,
            latest_leads_only: 1,
            assignment_type: assignmentType,
            assignees: individualUserIds,
            group_user_assignments: groupUserAssignments,
            profile_id: value.profile_id,
             fetchWebhook : fetchWebhook,
          },
          {
            headers: {
              Authorization: `Bearer ${
                getCurrentUser().token == null ? "" : getCurrentUser().token
              }`,
            },
          }
        )
        .then(function (res) {
          if (res.data.status) {
            setLoading(false)
            props.getWebApi()
            props.setnewModal_standard(false)
            toast.success(res.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            })
            console.log("Hi", res.data.message)
          } else {
            setLoading(false)
            toast.error(res.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            })
          }
        })
    }
  }

  const options = []

  if (allUsers !== undefined) {
    allUsers.map(item => {
      options.push({
        value: item.id,
        label: item.name,
      })
    })
  }

  const getSelectedId = e => {
    selectedUserId = []
    e?.map(item => selectedUserId.push(item.value))
  }

  const handleUserSelection = (selectedOptions, actionMeta) => {
    // Handle selection from All Users tab only
    setSelectedAllUsers(selectedOptions || [])
  }

  const handleGroupUserSelection = (selectedOptions, groupId) => {
    // Handle selection from a specific group independently
    // Update state for this specific group
    setSelectedGroupUsers(prev => ({
      ...prev,
      [groupId]: selectedOptions || [],
    }))
  }

  // Helper function to build the final selectedUserId based on active tab
  // Note: This is only used for 'all' mode now, groups mode uses group_user_assignments
  const buildSelectedUserIds = () => {
    if (selectedView === "all") {
      // Use selections from All Users tab
      return selectedAllUsers.map(user => user.value)
    } else {
      // For groups mode, return empty array since we use group_user_assignments
      return []
    }
  }

  const dValues = []

  useEffect(() => {
    getAllSource()
    getAllUsers()
    getAllGroups()
    getAllLeadSequence()
    if (props.fetch !== undefined) {
      selectedUserId = []
      const preselectedUsers = []

      console.log("Initializing fetch webhook with data:", {
        assignment_type: props.fetch.assignment_type,
        has_group_assignments: !!props.fetch.group_assignments,
        group_assignments_count: props.fetch.group_assignments?.length || 0,
        has_assigneename: !!props.fetch.assigneename,
        assigneename_count: props.fetch.assigneename?.length || 0,
      })

      // Determine the assignment type and set the view accordingly
      if (props.fetch.assignment_type === "groups") {
        console.log("Setting view to GROUPS mode")
        setSelectedView("groups")
        // Don't preselect "all users" when in groups mode
        setSelectedAllUsers([])
        setSelectedGroupUsers({})
      } else {
        console.log("Setting view to ALL USERS mode")
        setSelectedView("all")
        // Handle user assignments for "all" mode
        props.fetch.assigneename?.map(item => {
          const userOption = {
            value: item.id,
            label: item.name,
          }
          dValues.push(userOption)
          preselectedUsers.push(userOption)
          selectedUserId.push(item.id)
        })

        // Set preselected users for controlled component
        setSelectedAllUsers(preselectedUsers)
        // Clear any group selections
        setSelectedGroupUsers({})
      }
    }
  }, [])

  // Initialize group selections when groups are loaded and we're editing
  useEffect(() => {
    if (props.fetch !== undefined && Object.keys(groupedUsers).length > 0) {
      console.log("Group selections useEffect triggered:", {
        has_fetch: !!props.fetch,
        assignment_type: props.fetch.assignment_type,
        has_group_user_assignments: !!props.fetch.group_user_assignments,
        group_user_assignments: props.fetch.group_user_assignments,
        groupedUsers_count: Object.keys(groupedUsers).length,
      })

      // Load group selections if we have group_user_assignments data
      if (
        props.fetch.group_user_assignments &&
        props.fetch.group_user_assignments.length > 0
      ) {
        const groupSelections = {}

        console.log(
          "Processing group user assignments:",
          props.fetch.group_user_assignments
        )

        // Load group assignments from the group_user_assignments property
        props.fetch.group_user_assignments.forEach(groupAssignment => {
          const groupId = groupAssignment.group_id

          console.log(
            `Loading users for group ${groupId} (${groupAssignment.group}):`,
            groupAssignment.users
          )

          // Map the users that were selected for this group
          const groupUserSelections = groupAssignment.users.map(user => ({
            value: user.id,
            label: user.name || user.email || `User ${user.id}`,
          }))

          if (groupUserSelections.length > 0) {
            groupSelections[groupId] = groupUserSelections
          }
        })

        console.log(
          "✅ Loading group selections from group_user_assignments:",
          groupSelections
        )
        setSelectedGroupUsers(groupSelections)
      } else {
        console.log("No group_user_assignments data found")
        // Don't clear selections here - keep any existing ones
      }
    } else if (props.fetch === undefined) {
      console.log("No fetch data - creating new webhook")
      setSelectedGroupUsers({})
    }
  }, [groupedUsers, props.fetch])

  useEffect(() => {
    console.log(
      "State updated - allGroups:",
      allGroups,
      "groupedUsers:",
      groupedUsers
    )
  }, [allGroups, groupedUsers])

  useEffect(() => {
    const close = e => {
      if (e.key === "Escape") {
        props.setnewModal_standard(false)
      }
    }
    window.addEventListener("keydown", close)
    return () => window.removeEventListener("keydown", close)
  }, [])

  return (
    <>
      <Modal isOpen={props.nwemodal_standard} centered={true}>
        <AvForm
          className="modal-title mt-0"
          id="myModalLabel"
          onValidSubmit={(e, v) => {
            submitFetch(e, v)
          }}
        >
          <div className="modal-header">
            <h5 className="modal-title mt-0" id="myLargeModalLabel">
              {props.fetch !== undefined
                ? "Edit Fetch Status "
                : "Fetch From Webhook"}
            </h5>
            <button
              type="button"
              className="cross__btn"
              onClick={() => props.setnewModal_standard(false)}
              aria-hidden="true"
            >
              &times;
            </button>
          </div>
          <div className="modal-body">
            <div className="form-group mb-3">
              <AvField
                className="select-arrow"
                label="Select Lead Source"
                type="select"
                name="platform"
                defaultValue={props.fetch && props.fetch.platform}
                onChange={e => handlenewSource(e.target.value)}
              >
                <option value="" hidden>
                  Select Source Name
                </option>
                {Object.entries({
                  ...sourceOptions,
                  nexttech_mart:
                    sourceOptions.nexttech_mart ||
                    `https://klikcrm.com/api/${localStorage.getItem(
                      "company_name"
                    )}/webhook/nexttechmart`,
                  pharma_dove_bazaar:
                    sourceOptions.pharma_dove_bazaar ||
                    `https://klikcrm.com/api/${localStorage.getItem(
                      "company_name"
                    )}/webhook/pharmadovebazaar`,
                }).map(([key]) => (
                  <option key={key} value={key}>
                    {key === "nexttech_mart"
                      ? "Nexttech Mart"
                      : key === "pharma_dove_bazaar"
                      ? "Pharma Dove Bazaar"
                      : key.replace("_", " ").toUpperCase()}
                  </option>
                ))}
              </AvField>

              {showFacebookDocs && (
                <div className="mt-2">
                  <div className="alert alert-info d-flex align-items-center">
                    <i className="fas fa-info-circle me-2"></i>
                    <span className="me-2">
                      Need to connect your Facebook account?
                    </span>
                    <a
                      href="/connect-meta"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-sm btn-outline-primary"
                    >
                      <i className="fas fa-external-link-alt me-1"></i>
                      Connect Meta Account
                    </a>
                  </div>
                </div>
              )}
            </div>

            <div className="mb-3 bg-disable">
              {loading ? (
                <div>Loading...</div>
              ) : (
                <AvField
                  label="Webhook URL"
                  type="text"
                  name="api_key"
                  value={props?.fetch ? props.fetch.api_key : api_value}
                  disabled
                />
              )}
            </div>

            <div className="form-group mb-3">
              <AvField
                className="select-arrow"
                type="select"
                name="lead_source_id"
                label="Assign Source Name"
                defaultValue={props.fetch && props.fetch.lead_source_id}
              >
                <option value="" hidden>
                  Select Source Name
                </option>
                {allSource &&
                  allSource.map((item, i) => (
                    <option value={item.id} key={i}>
                      {item.name}
                    </option>
                  ))}
              </AvField>
            </div>
            {!isSequenceTab && (
              <>
            <div className="mb-3">
              <label className="form-label">Assignment Type</label>

              <div className="d-flex gap-3">

                {/* Individual */}
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="assignType"
                    value="individual"
                    checked={assignType === "individual"}
                    onChange={(e) => setAssignType(e.target.value)}
                  />
                  <label className="form-check-label">Individual</label>
                </div>

                {/* Group - show only if groups exist */}
                {hasGroups && (
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="assignType"
                      value="group"
                      checked={assignType === "group"}
                      onChange={(e) => setAssignType(e.target.value)}
                    />
                    <label className="form-check-label">Group</label>
                  </div>
                )}

                {/* Sequence */}
                {hasSequence && (
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="assignType"
                    value="sequence"
                    checked={assignType === "sequence"}
                    onChange={(e) => setAssignType(e.target.value)}
                  />
                  <label className="form-check-label">Sequence</label>
                </div>
                )}
              </div>
            </div>
            <div className="form-group mb-3">
              <label>Select Users To Assign</label>
              <p className="text-muted small">
                You can assign users individually and/or by groups. Both
                assignment methods will be active simultaneously.
              </p>

              {/* Individual Users Section */}
              {assignType === "individual" && (
                  <div className="mb-4">
                    <h6 className="text-primary mb-2">
                      <i className="fas fa-user me-2"></i>Individual Users
                    </h6>

                    <Select
                      isMulti
                      isClearable={true}
                      name="all_users_select"
                      options={options}
                      value={selectedAllUsers}
                      onChange={e => handleUserSelection(e)}
                      placeholder="Select individual users..."
                    />
                  </div>
                )}

              {/* Groups Section */}
              {assignType === "group" && hasGroups && (
              <div className="mb-3">
                <h6 className="text-success mb-2">
                  <i className="fas fa-users me-2"></i>Group-based Assignment
                </h6>

                {groupsLoading ? (
                  <div className="border rounded p-4 text-center">
                    <div
                      className="spinner-border text-primary mb-2"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="text-muted mb-0">Loading groups...</p>
                  </div>
                ) : (allGroups && allGroups.length > 0) ||
                  Object.keys(groupedUsers).length > 0 ? (
                  // Show groups from groupedUsers if available, otherwise from allGroups
                  Object.keys(groupedUsers).length > 0 ? (
                    Object.entries(groupedUsers).map(([groupId, groupData]) => {
                      console.log(
                        `Rendering group ${groupData.name}:`,
                        groupData
                      )

                      const groupUserOptions =
                        groupData.users && groupData.users.length > 0
                          ? groupData.users.map(user => ({
                              value: user.id,
                              label:
                                user.name || user.username || `User ${user.id}`,
                            }))
                          : []

                      console.log(
                        `Group ${groupData.name} user options:`,
                        groupUserOptions
                      )

                      return (
                        <div key={`group-${groupId}`} className="mb-3">
                          <div className="d-flex align-items-center mb-2">
                            <h6 className="text-primary mb-0 me-2">
                              {groupData.name}
                            </h6>
                            <span className="badge bg-danger">
                              {groupData.users ? groupData.users.length : 0}{" "}
                              users
                            </span>
                          </div>
                          <div className="">
                            {groupData.users && groupData.users.length > 0 ? (
                              <Select
                                isMulti
                                isClearable={true}
                                name={`group_${groupId}_users`}
                                options={groupUserOptions}
                                value={selectedGroupUsers[groupId] || []}
                                onChange={e =>
                                  handleGroupUserSelection(e, groupId)
                                }
                                placeholder={`Select users from ${groupData.name}...`}
                                className="basic-multi-select"
                                classNamePrefix="select"
                              />
                            ) : (
                              <div>
                                <p className="text-muted mb-1 fst-italic">
                                  No users assigned to this group
                                </p>
                                <small className="text-muted">
                                  Debug: {JSON.stringify(groupData)}
                                </small>
                              </div>
                            )}
                          </div>
                        </div>
                      )
                    })
                  ) : (
                    // Fallback: show groups from allGroups if groupedUsers is empty
                    allGroups.map(group => (
                      <div key={`fallback-group-${group.id}`} className="mb-3">
                        <div className="d-flex align-items-center mb-2">
                          <h6 className="text-primary mb-0 me-2">
                            {group.name}
                          </h6>
                          <span className="badge bg-warning">
                            Loading users...
                          </span>
                        </div>
                        <div className="alert alert-warning mb-0 small">
                          <i className="fas fa-exclamation-triangle me-2"></i>
                          Users for this group are still loading or couldn't be
                          fetched.
                          <br />
                          <small>Group data: {JSON.stringify(group)}</small>
                        </div>
                      </div>
                    ))
                  )
                ) : (
                  <div className="border rounded p-3">
                    <div className="text-center">
                      <i className="fas fa-users fa-2x text-muted mb-2"></i>
                      <p className="text-muted mb-0">No groups available</p>
                      <small className="text-muted">
                        Groups will appear here once they are created in the
                        system.
                      </small>
                    </div>
                  </div>
                )}
              </div>
              )}
              {assignType === "sequence" && (
              <div className="mb-3">
                <h6 className="text-warning mb-2">
                  <i className="fas fa-stream me-2"></i>Sequence Assignment
                </h6>

                {sequenceData.length > 0 ? (
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead className="table-light">
                        <tr>
                          <th>#</th>
                          <th>User Name</th>
                          <th>Sequence Order</th>
                          <th>Next Assigne</th>
                        </tr>
                      </thead>

                      <tbody>
                        {sequenceData.map((item, index) => (
                          <tr
                            key={item.id}
                            className={item.is_pointer === 1 ? "table-success" : ""}
                          >
                            <td>{index + 1}</td>
                            <td>{item.user_name}</td>
                            <td>{item.sequence_order}</td>
                            <td>
                              {item.is_pointer === 1 ? (
                                <span className="badge bg-success">Active</span>
                              ) : (
                                <span className="badge bg-secondary">Inactive</span>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <p className="text-muted">No sequence data found</p>
                )}
              </div>
            )}
            </div>
            </>
              )}
            <div className="modal-footer">
              <div className="text-center">
                {loading ? (
                  <button
                    className="btn btn-primary disabled"
                    type="button"
                    disabled
                  >
                    Loading
                  </button>
                ) : (
                  <button
                    className="btn btn-primary"
                    type="submit"
                    //   onClick={() => props.setnewModal_standard(false)}
                  >
                    {props.fetch !== undefined ? "Submit" : "Create"}
                  </button>
                )}
              </div>
            </div>
          </div>
        </AvForm>
      </Modal>
    </>
  )
}
